module.exports = __webpack_public_path__ + "img/error.c63b42b3.png";